module.exports = __webpack_public_path__ + "static/img/2.6ce3b0f2.png";